import React from "react";
import { useSelector } from "react-redux";
import { findEntityById } from "@qgiv/core-js";
import { useFormikContext } from "formik";
import { selectAllP2pSettings } from "../../../redux/slices/p2pSettingsSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import TeamModal from "./TeamModal";

const ConnectedTeamModal = () => {
    const { values } = useFormikContext();
    const { enableTeamJoin } = useSelector(selectAllP2pSettings);
    const categories = useSelector(selectAllCategories);

    const { Category } = values;

    const selectedCategory =
        Category &&
        Category.length > 0 &&
        categories.find(findEntityById(Number(Category[0])));

    // If Category selected doesn't allow team join,
    // we want to start the user on the Team Create view
    const { attachTeamCaptains, attachTeamMembers } = selectedCategory;
    const displayTeamCreateInitially = attachTeamCaptains && !attachTeamMembers;

    const teamModalProps = {
        displayTeamCreateInitially,
        enableTeamJoin,
    };
    return <TeamModal {...teamModalProps} />;
};

export default ConnectedTeamModal;
